import { useEffect, useState } from 'react'
import { Box, Card, CardHeader, CardBody, Heading, Text, Spinner, VStack } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { AssignedDeviceForm } from '@/components/forms/AssignedDeviceForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditAssignedDevicePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const numericId = id ? parseInt(id, 10) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (numericId == null || Number.isNaN(numericId)) {
      navigate('/access-control/assigned-devices', { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [numericId, navigate])

  if (isValidating || numericId == null) {
    return (
      <AdminLayout>
        <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
          <Card h="full" display="flex" flexDirection="column">
            <CardBody flex="1" display="flex" alignItems="center" justifyContent="center">
              <VStack spacing={4}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Assigned Device</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update device details and assignment.
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <AssignedDeviceForm
              deviceId={numericId}
              onSuccess={() => navigate('/access-control/assigned-devices')}
              onCancel={() => navigate('/access-control/assigned-devices')}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
